<template>
    <span>
         <v-btn icon class="mx-0" @click="deletewat()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>
   </span>
</template>

<script>
import {deleteModuleWithAttachment} from '@/model';
import moment from 'moment';

export default {
    name: 'DeleteWatch',
    props:{
        name :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deletewat() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will remove this movie from the watch now section, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            let datenow = moment().format('DD/MM/YYYY');
            console.log(datenow);
            
            
            deleteModuleWithAttachment('watch',this.name,function(response){
              if(response){
                    console.log("This is response: ",response);
                    
                   self.$store.dispatch('updateWatch',true);
                    alert('This has been successfully removed');
                    
                  }else{
                      alert("An error occured, please try again later.");
                      console.log(null);
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>